/**
 * VIEW_KEY
 * Enum representing calendar view types.
 *
 * @property DAY - Day view.
 * @property WEEK - Week view.
 * @property MONTH - Month view.
 * @property AGENDA - Agenda view.
 */
export enum VIEW_KEY {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  AGENDA = 'agenda',
}
